import * as React from "react";

import { AjaxManager } from "@impero-com/common/utils/ajax";
import { OrgCookie } from "@impero-com/common/utils/orgCookie";

import type { UserProfile } from "api/generated/model";
import { AvailableActions } from "api/generated/model";

import { Controls } from "..";

interface HalfYearlyControlsProps {
    ajaxManager: AjaxManager;
    orgCookie: OrgCookie;
    orgProfileCookie: UserProfile | null;
    availableActions: AvailableActions;
}

class HalfYearlyControls extends React.PureComponent<HalfYearlyControlsProps> {
    render = () => {
        const { ajaxManager, orgCookie, orgProfileCookie, availableActions } =
            this.props;

        return (
            <Controls
                schedulingTypeOrAll="HalfYearly"
                ajaxManager={ajaxManager}
                availableActions={availableActions}
                orgCookie={orgCookie}
                orgProfileCookie={orgProfileCookie}
            />
        );
    };
}

export { type HalfYearlyControlsProps, HalfYearlyControls };
